module.exports = __webpack_public_path__ + "img/orange_070.ef901802.png";